var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDeleteTool = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 36,
  height: 34,
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "none"
  },
  d: "M0 0h36v34H0z"
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M27 6c1.65 0 3 1.35 3 3v16c0 1.65-1.35 3-3 3H9c-1.65 0-3-1.35-3-3V9c0-1.65 1.35-3 3-3h18zm0 2H9c-.542 0-1 .458-1 1v16c0 .542.458 1 1 1h18c.542 0 1-.458 1-1V9c0-.542-.458-1-1-1zm-7.177 1.55a1.3 1.3 0 0 1 1.21.824l.517 1.313h3.95v1.3h-1.316L23.684 23a1.25 1.25 0 0 1-1.248 1.188h-8.872A1.25 1.25 0 0 1 12.316 23l-.502-10.013H10.5v-1.3h3.949l.518-1.313a1.3 1.3 0 0 1 1.21-.824h3.646zm3.06 3.438h-9.767l.495 9.9h8.777l.495-9.9zm-7.093 1.414 2.255 2.253 2.209-2.209 1.326 1.326-2.21 2.209 2.166 2.166-1.326 1.326-2.166-2.166-2.21 2.21-1.325-1.326 2.209-2.21-2.254-2.253 1.326-1.326zm4.033-3.552h-3.646l-.33.837h4.306l-.33-.837z",
  fill: "#707070"
})));
export default SvgDeleteTool;